export const STATUS_CODE = {
  SUCCESS: 0,
  CPP_SUCCESS: 1,
  TOKEN_ERROR: 401,
  NEED_PHONE_AUTH: 40001,
};

export const SEND_VERIFY_CODE_TYPE = {
  IM: 0,
  PHONE_MSG: 1,
};

export const SEND_VERIFY_CODE_SCENE = {
  SIGN: 0,
  CHECK_AUTH: 1,
  BIND_PHONE: 2,
};

export const COMMON_ERROR_TEXT = 'lang328';

// https://yapi.ppx520.com/project/8015/interface/api/335156
export const AGENT_ROLE = {
  NOT_AGENT: 0, // 未知
  SUPER_MANAGER: 1, // 超级管理员（代理
  MANAGER: 2, // 管理员
  BROKER: 3, // 经纪人
};

export const LOGIN_BAN_URL = [
  'https://agent-oss.hzmk.site/agent/',
  'https://agent-oss.linhty.xyz/agent/',
];

export const ANCHOR_STAR_STATUS = {
  PROCESS: 1,
  FINISH: 2,
};

export const ANCHOR_STAR_STATUS_LANG = {
  [ANCHOR_STAR_STATUS.PROCESS]: 'lang1419',
  [ANCHOR_STAR_STATUS.FINISH]: 'lang1420',
};
